import axios from 'axios';
axios.defaults.baseURL = 'https://hellosigns.herokuapp.com';
export default axios;